import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SegmentComponent } from './pages/segment/segment.component';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsModule } from '@app/shared/modules/analytics/analytics.module';
import { EvcSegmentRoutingModule } from './evc-segment-routing.module';

@NgModule({
  declarations: [SegmentComponent],
  imports: [CommonModule, EvcSegmentRoutingModule, SharedModule, TranslateModule, AnalyticsModule],
})
export class EvcSegmentModule {}
